<template>
  <div>
    <div id="bar">
      <div
        style="margin-left: 17.1%; border: solid 2px #E5E5E5; padding-top: 5px; padding-bottom: 5px; position:fixed; top: 0; left: 0; width: 66.5%;z-index: 10; background-color: white">
        <span style="margin-left: 10px; float: left">当前用户名：学信网账号</span>
        <span style="margin-left: 50px; margin-right: 50px; float: right;">退出登录</span>
        <span style="float: right;">返回首页</span>
        <div class="clear"></div>
      </div>
      <div id="title" style="margin-top: 35px">
        <img src="http://public-img.51easymaster.com/341c5ceb-4f96-4135-be42-b3b57a53c5d4.png" style="width: 100%;"/>
      </div>
      <el-row class="tac"
              style="margin-left: 16.85%; margin-top: 145px; width: 1270px; border-right: solid 1px #E5E5E5;">
        <el-col :span="4"
                style="width: 12%; height: 99%; position: fixed; border-left: solid 1px #E5E5E5; border-right: solid 1px #E5E5E5;">
          <h4>报名流程</h4>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-vertical-demo"
            @select="handleSelect"
            style="border-right: 0px">
            <el-menu-item index="1" disabled
                          style="opacity: .5; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">
              <span>1.</span>
              <span slot="title">网上报名公告</span>
            </el-menu-item>
            <el-menu-item index="2" disabled
                          style="opacity: .5; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">
              <span>2.</span>
              <span slot="title">填写考生信息</span>
            </el-menu-item>
            <el-menu-item index="3" disabled
                          style="opacity: .5; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">
              <span>3.</span>
              <span slot="title">阅读考试承诺书</span>
            </el-menu-item>
            <el-menu-item index="4" disabled
                          style="opacity: 1; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">
              <span>4.</span>
              <span slot="title">选择报考的单位</span>
            </el-menu-item>
            <!--<el-menu-item index="4" disabled style="opacity: 1; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">-->
            <!--<span>4.</span>-->
            <!--<span slot="title">填写个人信息1</span>-->
            <!--</el-menu-item>-->
            <!--<el-menu-item index="5" disabled style="opacity: 1; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">-->
            <!--<span>5.</span>-->
            <!--<span slot="title">填写个人信息2</span>-->
            <!--</el-menu-item>-->
            <!--<el-menu-item index="6" disabled style="opacity: 1; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">-->
            <!--<span>6.</span>-->
            <!--<span slot="title">填写个人信息3</span>-->
            <!--</el-menu-item>-->
            <el-menu-item index="5" disabled
                          style="opacity: 1; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">
              <span>5.</span>
              <span slot="title">选择报考的专业</span>
            </el-menu-item>
            <el-menu-item index="6" disabled
                          style="opacity: 1; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">
              <span>6.</span>
              <span slot="title">选择报考点</span>
            </el-menu-item>
            <el-menu-item index="7" disabled
                          style="opacity: 1; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">
              <span>7.</span>
              <span slot="title">校对填报信息</span>
            </el-menu-item>
            <el-menu-item index="8" disabled
                          style="opacity: 1; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">
              <span>8.</span>
              <span slot="title">完成报名</span>
            </el-menu-item>
            <!--<el-menu-item index="9" disabled-->
                          <!--style="opacity: .5; padding-left: 11%;margin-left: 10%; margin-right: 10%; border-bottom: solid 1px #E5E5E5;">-->
              <!--<span>9.</span>-->
              <!--<span slot="title">学籍学历校验结果</span>-->
            <!--</el-menu-item>-->
          </el-menu>
        </el-col>
        <div id="text">
          <div id="text4">
            <div class="tips">
              <h5 style="font-size: 18px; margin-top: 20px; margin-bottom: 20px">选择报考单位以及考试方式、专项计划</h5>
              <p style="font-size: 14px">(请仔细阅读选择省市和招生单位后面下方显示的网报公告，以免导致报名无效)</p>
            </div>
            <div style="padding-bottom: 30px; border-bottom: solid 1px #E5E5E5">
              <div style="margin-top: 30px">
                <span style="margin-right: 36px">招生单位：</span>
                <span style="color: red; font-size: 20px; display: inline-block;vertical-align: middle;">
                  *
                </span>
                <el-select v-model="unit_city" placeholder="（11）北京市" @change="currentUnitCity"
                           style="border: 1px solid black; border-radius: 4px;">
                  <el-option
                    v-for="item in unit_cities"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
                <span style="margin-left: 5px;color: red; font-size: 20px; display: inline-block;vertical-align: middle;">
                  *
                </span>
                <el-select v-model="unit_university" placeholder="（10009）北方工业大学"
                           style=" border: 1px solid black; border-radius: 4px;"
                           @change="currentUnitUniversity">
                  <el-option
                    v-for="item in unit_universities"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
                <p style="font-size: 14px; margin-left: 135px; margin-bottom: 30px">(按照单位名称排序)你选择报考的学校</p>
              </div>
              <div>
                <span style="margin-right: 36px">考试方式：</span>
                <span style="color: red; font-size: 20px; display: inline-block;vertical-align: middle;">
                  *
                </span>
                <el-select v-model="exam_method_value" placeholder="全国统考"
                           style="border: 1px solid black; border-radius: 4px;">
                  <el-option
                    v-for="item in exam_method"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                  </el-option>
                </el-select>
                <span style="font-size: 14px; margin-left: 20px">各类考试方式和专项计划的概括以及关系</span>
              </div>
              <div style="margin-top: 30px">
                <span style="margin-right: 50px">专项计划：</span>
                <el-select v-model="special_plan_value" placeholder="无"
                           style="border: 1px solid black; border-radius: 4px;">
                  <el-option
                    v-for="item in special_plan"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="text-align: center;">
              <router-link to="/wangshangdiaocha">
                <el-button type="primary" plain style="margin-top: 20px">上一步</el-button>
              </router-link>
              <el-button type="primary" plain style="margin-top: 20px; margin-left: 80px" @click="handleSelect('5')">
                下一步
              </el-button>
            </div>
            <div style="height: 377px;"></div>
          </div>
          <!--<div id="text4">-->
          <!--<div class="tips">-->
          <!--<h5 style="font-size: 18px; margin-top: 20px; margin-bottom: 20px">个人信息填写1</h5>-->
          <!--<p style="font-size: 14px">(请仔细阅读选择省市和招生单位后面下方显示的网报公告，以免导致报名无效)</p>-->
          <!--</div>-->
          <!--<div style="margin-top: 30px; border-bottom: solid 1px #E5E5E5">-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 82px">姓名：</span>-->
          <!--<el-input-->
          <!--v-model="student_name"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="width: 500px; border: 1px solid black; border-radius: 4px;">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">姓名拼音：</span>-->
          <!--<el-input-->
          <!--v-model="student_name_pinyin"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="width: 500px; border: 1px solid black; border-radius: 4px;">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">证件类型：</span>-->
          <!--<el-select v-model="card_type_value" placeholder="大陆身份证" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in card_type"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">证件号码：</span>-->
          <!--<el-input-->
          <!--v-model="student_card_number"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="width: 500px; border: 1px solid black; border-radius: 4px;">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">现役军人：</span>-->
          <!--<el-select v-model="serving_soldier_value" placeholder="非现役军人" style=" border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in serving_soldier"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">考生民族：</span>-->
          <!--<el-select v-model="national_value" filterable placeholder="汉族" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in national"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">考生性别：</span>-->
          <!--<el-select v-model="sex_value" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in sex"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">婚姻状况：</span>-->
          <!--<el-select v-model="marriage_value" placeholder="未婚" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in marriage"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">政治面貌：</span>-->
          <!--<el-select v-model="political_outlook_value" placeholder="中国共产主义青年团团员" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in political_outlook"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 18px">考生通信地址：</span>-->
          <!--<el-input-->
          <!--v-model="student_mail_address"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--<p style="font-size: 14px; margin-left: 135px; margin-bottom: 30px">为考生接受录取通知书地址，考生务必真实准确填写</p>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">邮政编码：</span>-->
          <!--<el-input-->
          <!--v-model="student_zip_code"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">固定电话：</span>-->
          <!--<el-input-->
          <!--v-model="student_telephone"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">移动电话：</span>-->
          <!--<el-input-->
          <!--v-model="student_mobile_phone"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">电子邮件：</span>-->
          <!--<el-input-->
          <!--v-model="student_email"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--</div>-->
          <!--<div style="text-align: center; margin-bottom: 150px">-->
          <!--<el-button type="primary" plain style="margin-top: 20px" @click="handleSelect('3')">上一步</el-button>-->
          <!--<el-button type="primary" plain style="margin-top: 20px; margin-left: 80px" @click="handleSelect('5')">下一步</el-button>-->
          <!--</div>-->
          <!--</div>-->
          <!--<div id="text5">-->
          <!--<div class="tips">-->
          <!--<h5 style="font-size: 18px; margin-top: 20px; margin-bottom: 20px">个人信息填写2</h5>-->
          <!--<p style="font-size: 14px">(请仔细阅读选择省市和招生单位后面下方显示的网报公告，以免导致报名无效)</p>-->
          <!--</div>-->
          <!--<div style="margin-top: 30px; border-bottom: solid 1px #E5E5E5">-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">考生来源：</span>-->
          <!--<el-select v-model="sources_value" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in sources"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<span style="font-size: 14px; margin-left: 20px">无正式工作的往届生选择‘其他人员’</span>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 30px; display: inline-block; width: 100px;">取得最后学历的学习形式：</span>-->
          <!--<el-select v-model="end_learn_way_value" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in end_learn_way"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">最后学历：</span>-->
          <!--<el-select v-model="final_education_value" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in final_education"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 82px">学号：</span>-->
          <!--<el-input-->
          <!--v-model="student_number"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 218px">-->
          <!--</el-input>-->
          <!--<span style="font-size: 14px; margin-left: 20px">应届生必须填写，往届生不用填写（可登陆学信档案验证本人学籍或学历）</span>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 17px">毕业证书编号：</span>-->
          <!--<el-input-->
          <!--v-model="student_diploma_number"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 218px">-->
          <!--</el-input>-->
          <!--<span style="font-size: 14px; margin-left: 20px">应届生必须填写，往届生不用填写（可登陆学信档案验证本人学籍或学历）</span>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 30px; display: inline-block; width: 100px;">取得最后学历的毕业年月：</span>-->
          <!--<el-select v-model="years_value" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in years"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<span>年</span>-->
          <!--<el-select v-model="monthes_value" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in monthes"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<span>月</span>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">最后学位：</span>-->
          <!--<el-select v-model="final_degree_value" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in final_degree"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 17px">学位证书编号：</span>-->
          <!--<el-input-->
          <!--v-model="student_degree_number"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 218px">-->
          <!--</el-input>-->
          <!--<span style="font-size: 14px; margin-left: 20px">应届生必须填写，往届生不用填写（可登陆学信档案验证本人学籍或学历）</span>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">毕业学校：</span>-->
          <!--<el-select v-model="graduate_city" placeholder="&#45;&#45;请选择&#45;&#45;" @change="currentGraduateCity" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in unit_cities"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="graduate_university" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" @change="currentGraduateUniversity">-->
          <!--<el-option-->
          <!--v-for="item in graduate_universities"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">毕业专业：</span>-->
          <!--<el-select v-model="graduate_college" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" @change="currentGraduateCollege($event, )">-->
          <!--<el-option-->
          <!--v-for="item in graduate_colleges"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="graduate_profession" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in graduate_professions"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<p style="font-size: 14px; margin-left: 135px; margin-bottom: 30px">因模拟系统无法搜集全国所有本科学校的所有专业，此处可不选，但预报名和正式报名一定要选</p>-->
          <!--&lt;!&ndash;<p style="margin-left: 135px; font-size: 14px">因模拟系统无法搜集全国所有本科学校的所有专业，此处可不选，但预报名和正式报名一定要选</p>&ndash;&gt;-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">报考类别：</span>-->
          <!--<el-select v-model="exam_category_value" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;">-->
          <!--<el-option-->
          <!--v-for="item in exam_category"-->
          <!--:key="item.value"-->
          <!--:label="item.label"-->
          <!--:value="item.label">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<span style="font-size: 14px; margin-left: 20px">除去特殊情况，一般都选非定向就业</span>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 50px">备用信息：</span>-->
          <!--<el-input-->
          <!--v-model="student_alternate_info"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 218px">-->
          <!--</el-input>-->
          <!--<p style="font-size: 14px; margin-left: 135px; margin-bottom: 30px">根据招生单位要求填写（请参考报考学校招生简章，如果简章没有要求可以不用填写）</p>-->
          <!--&lt;!&ndash;<span style="font-size: 14px; margin-left: 20px">根据招生单位要求填写（请参考报考学校招生简章，如果简章没有要求可以不用填写）</span>&ndash;&gt;-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 42px">备用信息1：</span>-->
          <!--<el-input-->
          <!--v-model="student_alternate_info1"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 218px">-->
          <!--</el-input>-->
          <!--<p style="font-size: 14px; margin-left: 135px; margin-bottom: 30px">根据招生单位要求填写（请参考报考学校招生简章，如果简章没有要求可以不用填写）</p>-->
          <!--</div>-->
          <!--</div>-->
          <!--<div style="text-align: center; margin-bottom: 150px">-->
          <!--<el-button type="primary" plain style="margin-top: 20px" @click="handleSelect('4')">上一步</el-button>-->
          <!--<el-button type="primary" plain style="margin-top: 20px; margin-left: 80px" @click="handleSelect('6')">下一步</el-button>-->
          <!--</div>-->
          <!--</div>-->
          <!--<div id="text6">-->
          <!--<div class="tips">-->
          <!--<h5 style="font-size: 18px; margin-top: 20px; margin-bottom: 20px">个人信息填写3</h5>-->
          <!--<p style="font-size: 14px">(注意：在输入数字或字母时，请使用半角字符，否则可能会造成报名失败)</p>-->
          <!--</div>-->
          <!--<div style="margin-top: 30px; border-bottom: solid 1px #E5E5E5">-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 48px">考生籍贯：</span>-->
          <!--<el-select v-model="origin_province" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small" @change="currentOriginProvince">-->
          <!--<el-option-->
          <!--v-for="item in provinces"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="origin_city" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small" @change="currentOriginCity">-->
          <!--<el-option-->
          <!--v-for="item in origin_cities"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="origin_county" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small">-->
          <!--<el-option-->
          <!--v-for="item in origin_counties"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 33px">户口所在地：</span>-->
          <!--<el-select v-model="location_province" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small" @change="currentLocationProvince">-->
          <!--<el-option-->
          <!--v-for="item in provinces"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="location_city" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small" @change="currentLocationCity">-->
          <!--<el-option-->
          <!--v-for="item in location_cities"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="location_county" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small">-->
          <!--<el-option-->
          <!--v-for="item in location_counties"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<p style="font-size: 14px; margin-left: 135px; margin-top: 14px; margin-bottom: 0px">请按照户口本上的信息填写</p>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 30px; display: inline-block; width: 100px;">户口所在地详细地址：</span>-->
          <!--<el-input-->
          <!--v-model="student_detail_address"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 35px">出生地省市：</span>-->
          <!--<el-select v-model="birth_province" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small" @change="currentBirthProvince">-->
          <!--<el-option-->
          <!--v-for="item in provinces"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="birth_city" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small" @change="currentBirthCity">-->
          <!--<el-option-->
          <!--v-for="item in birth_cities"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="birth_county" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small">-->
          <!--<el-option-->
          <!--v-for="item in birth_counties"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 30px; display: inline-block; width: 100px;">现在学习或工作单位：</span>-->
          <!--<el-input-->
          <!--v-model="student_study_work_unit"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 2px">考生档案所在地：</span>-->
          <!--<el-select v-model="file_province" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small" @change="currentFileProvince">-->
          <!--<el-option-->
          <!--v-for="item in provinces"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="file_city" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small" @change="currentFileCity">-->
          <!--<el-option-->
          <!--v-for="item in file_cities"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="file_county" placeholder="&#45;&#45;请选择&#45;&#45;" style="border: 1px solid black; border-radius: 4px;" size="small">-->
          <!--<el-option-->
          <!--v-for="item in file_counties"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<p style="font-size: 14px; margin-left: 135px; margin-top: 14px; margin-bottom: 0px">应届生：档案所在地即自己的本科学校</p>-->
          <!--<p style="font-size: 14px; margin-left: 135px; margin-top: 0px; margin-bottom: 0px">往届生：</p>-->
          <!--<p style="font-size: 14px; margin-left: 135px; margin-top: 0px; margin-bottom: 0px">1、如果有工作，并且你工作的地方有档案保存资质（可询问你的工作单位），你的 档案就在你的工作单位；</p>-->
          <!--<p style="font-size: 14px; margin-left: 135px; margin-top: 0px; margin-bottom: 30px">2、如果没有工作，你的档案所在地一般就在你户口所在地的人力资源局（可查看本科毕业时 ，学校给你发的报到证，报到证上填写的地址，就是你的档案所在地）</p>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 30px; display: inline-block; width: 100px;">考生档案所在单位名称：</span>-->
          <!--<el-input-->
          <!--v-model="student_unit_name"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 30px; display: inline-block; width: 100px;">考生档案所在单位地址：</span>-->
          <!--<el-input-->
          <!--v-model="student_unit_address"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 30px; display: inline-block; width: 100px;">考生档案所在单位名称邮政编码：</span>-->
          <!--<el-input-->
          <!--v-model="student_unit_zip_code"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 30px; display: inline-block; width: 100px;">何时何地何原因受过何种奖励或处分：</span>-->
          <!--<el-input-->
          <!--type="textarea"-->
          <!--:rows="2"-->
          <!--v-model="student_reward_punish"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 30px; display: inline-block; width: 100px;">考生作弊情况：</span>-->
          <!--<el-input-->
          <!--type="textarea"-->
          <!--:rows="2"-->
          <!--v-model="student_cheat"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 500px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<p style="font-size: 14px; margin-bottom: 30px">考生报名时如实填写参加普通和成人高等学校招生考试、全国硕士研究生招生考试、高等教育自学考试等国家教育考试过程中作弊情况。（填写何时、何地、参加何种考试、作弊事实）</p>-->
          <!--<p style="font-size: 14px; margin-bottom: 30px">家庭主要成员（必填。所有字数加到一起最多200个字节的字符）</p>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 158px">姓名</span>-->
          <!--<span style="margin-right: 110px">与本人关系</span>-->
          <!--<span style="margin-right: 20px">在何单位工作/任何职务</span>-->
          <!--<span style="margin-right: 150px">联系电话</span>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<el-input-->
          <!--v-model="student_family_name1"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_family_relate1"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_family_work1"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_family_phone1"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<el-input-->
          <!--v-model="student_family_name2"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_family_relate2"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_family_work2"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_family_phone2"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<el-input-->
          <!--v-model="student_family_name3"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_family_relate3"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_family_work3"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_family_phone3"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--</div>-->
          <!--<p style="font-size: 14px; margin-bottom: 30px">学习与工作经历（高中毕业后起）（必填。所有字数加到一起最多200个字节的字符，请精简填写）</p>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<span style="margin-right: 125px">起止年月</span>-->
          <!--<span style="margin-right: 78px">学习或工作单位</span>-->
          <!--<span style="margin-right: 20px">任何职务</span>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<el-input-->
          <!--v-model="student_experience_time1"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_experience_location1"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_experience_work1"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<el-input-->
          <!--v-model="student_experience_time2"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_experience_location2"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_experience_work2"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<el-input-->
          <!--v-model="student_experience_time3"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_experience_location3"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_experience_work3"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<el-input-->
          <!--v-model="student_experience_time4"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_experience_location4"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_experience_work4"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div style="margin-bottom: 20px">-->
          <!--<el-input-->
          <!--v-model="student_experience_time5"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_experience_location5"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--<el-input-->
          <!--v-model="student_experience_work5"-->
          <!--placeholder="单行输入"-->
          <!--clearable style="border: 1px solid black; border-radius: 4px;width: 170px; margin-right: 20px">-->
          <!--</el-input>-->
          <!--</div>-->
          <!--</div>-->
          <!--</div>-->
          <!--<div style="text-align: center; margin-bottom: 150px">-->
          <!--<el-button type="primary" plain style="margin-top: 20px" @click="handleSelect('5')">上一步</el-button>-->
          <!--<el-button type="primary" plain style="margin-top: 20px; margin-left: 80px" @click="handleSelect('7')">下一步</el-button>-->
          <!--</div>-->
          <!--</div>-->
          <div id="text5">
            <div class="tips">
              <h5 style="font-size: 18px; margin-top: 20px; margin-bottom: 20px">选择报考的专业</h5>
              <p style="font-size: 14px">(请仔细阅读填写)</p>
            </div>
            <div style="margin-top: 30px; border-bottom: solid 1px #E5E5E5">
              <div style="margin-bottom: 20px">
                <span style="margin-right: 20px">报考单位名称：</span>
                <el-select v-model="unit_university" disabled placeholder="--请选择--"
                           style="border: 1px solid black; border-radius: 4px;">
                </el-select>
              </div>
              <div style="margin-bottom: 20px">
                <span style="margin-right: 6px">报考院系名称：</span>
                <span style="color: red; font-size: 20px; display: inline-block;vertical-align: middle;">
                  *
                </span>
                <el-select v-model="apply_college" placeholder="--请选择--"
                           style="border: 1px solid black; border-radius: 4px;" @change="currentApplyCollege">
                  <el-option
                    v-for="item in apply_colleges"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </div>
              <div style="margin-bottom: 20px">
                <span style="margin-right: 38px">报考专业：</span>
                <span style="color: red; font-size: 20px; display: inline-block;vertical-align: middle;">
                  *
                </span>
                <el-select v-model="apply_profession" placeholder="--请选择--"
                           style="border: 1px solid black; border-radius: 4px;" @change="currentApplyProfession">
                  <el-option
                    v-for="item in apply_professions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </div>
              <div style="margin-bottom: 20px">
                <span style="margin-right: 38px">研究方向：</span>
                <span style="color: red; font-size: 20px; display: inline-block;vertical-align: middle;">
                  *
                </span>
                <el-select v-model="apply_direction" placeholder="--请选择--"
                           style="border: 1px solid black; border-radius: 4px;">
                  <el-option
                    v-for="item in apply_directions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </div>
              <div style="margin-bottom: 20px">
                <span style="margin-right: 52px">考试科目：</span>
                <el-select v-model="apply_subject" disabled="" placeholder="--请选择--"
                           style="border: 1px solid black; border-radius: 4px;">
                </el-select>
                <span style="font-size: 14px; margin-left: 20px">模拟报名可不填，预报名和正式报名必须填写</span>
              </div>
              <p style="font-size: 14px; margin-bottom: 5px">注</p>
              <p style="font-size: 14px; margin-top: 0px; margin-bottom: 5px">1、报考专业中文名称前有（专业学位）字样的为全日制专业学位专业领域；</p>
              <p style="font-size: 14px; margin-top: 0px; margin-bottom: 5px">
                2、工商管理、公共管理、旅游管理、工程管理、及工程中的项目管理、教育管理、体育中的竞赛组织不允许应届生报考，请查看招生简介；</p>
              <p style="font-size: 14px; margin-top: 0px; margin-bottom: 5px">
                3、修改报名信息时，第四考试科目，考试时间超过三小时（考试科目代码第一位为5）与未超过三小时不可互相修改，如需修改必须新增报名，原报名号现场不确认即可；</p>
              <p style="font-size: 14px; margin-top: 0px; margin-bottom: 5px">4、考试科目的选择请结合实际情况，符合招生单位要求，否则招生单位可能不准考；</p>
              <p style="font-size: 14px; margin-top: 0px; margin-bottom: 30px">5、由于网络环境及系统复杂性，下拉列表内容显示的可能比较慢，请耐心等待；</p>
            </div>
            <div style="text-align: center;">
              <el-button type="primary" plain style="margin-top: 20px" @click="handleSelect('4')">上一步</el-button>
              <el-button type="primary" plain style="margin-top: 20px; margin-left: 80px" @click="handleSelect('6')">
                下一步
              </el-button>
            </div>
            <div style="height: 130px;"></div>
          </div>
          <div id="text6">
            <div class="tips">
              <h5 style="font-size: 18px; margin-top: 20px; margin-bottom: 20px">请选择报考所在省市及报考点名称</h5>
              <p style="font-size: 14px">(请仔细阅读选择省市和招生单位后面下方显示的网报公告，以免导致报名无效)</p>
            </div>
            <div style="margin-top: 30px; border-bottom: solid 1px #E5E5E5">
              <p style="font-size: 14px; margin-bottom: 30px">报考点的设置由各报考点所在省级管理部门设定，请仔细阅读报考点及省级管理部门 如仍有疑问请咨询省级管理部门</p>
              <div style="margin-bottom: 20px">
                <span style="margin-right: 52px">招生单位：</span>
                <el-select v-model="unit_university" disabled placeholder="--请选择--"
                           style="border: 1px solid black; border-radius: 4px;">
                </el-select>
              </div>
              <div style="margin-bottom: 20px">
                <span style="margin-right: 54px">报考点：</span>
                <span style="color: red; font-size: 20px; display: inline-block;vertical-align: middle;">
                  *
                </span>
                <el-input
                  v-model="apply_point"
                  placeholder="单行输入"
                  clearable style="border: 1px solid black; border-radius: 4px;width: 218px">
                </el-input>
                <span style="font-size: 14px; margin-left: 20px">根据报考点公告选取报考点即可</span>
              </div>
            </div>
            <div style="text-align: center;">
              <el-button type="primary" plain style="margin-top: 20px" @click="handleSelect('5')">上一步</el-button>
              <el-button type="primary" plain style="margin-top: 20px; margin-left: 80px" @click="handleSelect('7')">
                下一步
              </el-button>
            </div>
            <div style="height: 480px;"></div>
          </div>
          <div id="text7">
            <div class="tips">
              <h5 style="font-size: 18px; margin-top: 20px; margin-bottom: 20px">校对填报信息</h5>
              <p style="font-size: 14px; margin-top: 0px; margin-bottom: 5px">
                校对填报信息后，输入校验码，并点击页面下方按钮，才能生成报名号，完成填报工作！</p>
              <p style="font-size: 14px; margin-top: 0px; margin-bottom: 5px">
                请按教育部、本人所在地省级教育招生考试管理机构、报考点以及报考招生单位的网上公告要求报名，</p>
              <p style="font-size: 14px; margin-top: 0px; margin-bottom: 5px">
                但凡不按公告要求报名、网报信息误填、错填或填报虚假信息而造成不能考试或复试的，后果由考生本人承担。</p>
              <p style="font-size: 14px; margin-top: 0px; margin-bottom: 30px">确认选填信息正确无误，报考信息一旦提交不可修改!</p>
            </div>
            <div style="margin-top: 30px; border-bottom: solid 1px #E5E5E5">
              <table>
                <!--<tr>-->
                <!--<th>报考点</th>-->
                <!--<td id="baokaodian">{{ apply_point }}</td>-->
                <!--&lt;!&ndash;<th></th>&ndash;&gt;-->
                <!--&lt;!&ndash;<td></td>&ndash;&gt;-->
                <!--</tr>-->
                <tr>
                  <th>考生姓名</th>
                  <td id="personal_info-name">{{ student_name }}</td>
                  <th>考生拼音</th>
                  <td id="personal_info-name_py">{{ student_name_pinyin }}</td>
                </tr>
                <tr>
                  <th>证件类型</th>
                  <td id="personal_info-zhengjianleixing">{{ card_type_value }}</td>
                  <th>证件号码</th>
                  <td id="personal_info-zhengjianhaoma">{{ student_card_number }}</td>
                </tr>
                <tr>
                  <th>报考点</th>
                  <td id="baokaodian">{{ apply_point }}</td>
                  <!--<th>出生日期</th>-->
                  <!--<td></td>-->
                  <th>民族</th>
                  <td id="personal_info-minzu">{{ national_value }}</td>
                </tr>
                <tr>
                  <th>性别</th>
                  <td id="personal_info-sex">{{ sex_value }}</td>
                  <th>婚姻状况</th>
                  <td id="personal_info-is_married">{{ marriage_value }}</td>
                </tr>
                <tr>
                  <th>现役军人</th>
                  <td id="personal_info-is_xianyijunren">{{ serving_soldier_value }}</td>
                  <th>政治面貌</th>
                  <td id="personal_info-zhengzhimianmao">{{ political_outlook_value }}</td>
                </tr>
                <tr>
                  <th>户口所在地</th>
                  <td colspan="3"><span id="hukou_sheng">{{ location_province }}</span>-<span id="hukou_shi">{{ location_city }}</span>-<span
                    id="hukou_qu">{{ location_county }}</span></td>
                </tr>
                <tr>
                  <th>户口所在地详细地址</th>
                  <td colspan="3" id="hukou_xiangxidizhi">{{ student_detail_address }}</td>
                </tr>
                <tr>
                  <th>出生地</th>
                  <td colspan="3"><span id="chusheng_sheng">{{ birth_province }}</span>-<span id="chusheng_shi">{{ birth_city }}</span>-<span
                    id="chusheng_qu">{{ birth_county }}</span></td>
                </tr>
                <tr>
                  <th>现在学习或工作单位</th>
                  <td colspan="3" id="xianzaidanwei">{{ student_study_work_unit }}</td>
                </tr>
                <tr>
                  <th>通信地址</th>
                  <td colspan="3" id="personal_info-tongxundizhi">{{ student_mail_address }}</td>
                </tr>
                <tr>
                  <th>邮政编码</th>
                  <td id="personal_info-youzhengbianma">{{ student_unit_zip_code }}</td>
                  <th>固定电话</th>
                  <td id="personal_info-gudingdianhua">{{ student_telephone }}</td>
                </tr>
                <tr>
                  <th>移动电话</th>
                  <td colspan="3" id="personal_info-yidongdianhua">{{ student_mobile_phone }}</td>
                </tr>
                <tr>
                  <th>电子邮件</th>
                  <td id="personal_info-email">{{ student_email }}</td>
                  <th>最后毕业年月</th>
                  <td><span id="cur_school_info-biyenian">{{ years_value }}</span>-<span id="cur_school_info-biyeyue">{{ monthes_value }}</span>
                  </td>
                </tr>
                <tr>
                  <th>取得最后学历的学习形式</th>
                  <td colspan="3" id="cur_school_info-xuelixingshi">{{ end_learn_way_value }}</td>
                </tr>
                <tr>
                  <th>注册学号</th>
                  <td colspan="3" id="cur_school_info-xuehao">{{ student_number }}</td>
                </tr>
                <tr>
                  <th>最后学位</th>
                  <td id="cur_school_info-xuewei">{{ final_degree_value }}</td>
                  <th>最后学位证书编号</th>
                  <td id="cur_school_info-xueweizhengshubianhao">{{ student_degree_number }}</td>
                </tr>
                <tr>
                  <th>毕业学校</th>
                  <td><span id="cur_school_info-location">{{ graduate_city }}</span>-<span id="cur_school_info-school">{{ graduate_university }}</span>
                  </td>
                  <th>毕业专业</th>
                  <td><span id="cur_school_info-institute">{{ graduate_college }}</span>-<span
                    id="cur_school_info-major">{{ graduate_profession }}</span></td>
                </tr>
                <tr>
                  <th>考生来源</th>
                  <td id="cur_school_info-kaoshenglaiyuan">{{ sources_value }}</td>
                  <th>报考类别</th>
                  <td id="exam_info-baokaoleibie">{{ exam_category_value }}</td>
                </tr>
                <tr>
                  <th>考生档案所在地</th>
                  <td colspan="3"><span id="dangan_sheng">{{ file_province }}</span>-<span id="dangan_shi">{{ file_city }}</span>-<span
                    id="dangan_qu">{{ file_county }}</span></td>
                </tr>
                <!--<tr>-->
                <!--<th>定向就业单位所在地</th>-->
                <!--<td colspan="3" id=""></td>-->
                <!--</tr>-->
                <!--<tr>-->
                <!--<th>定向就业单位</th>-->
                <!--<td colspan="3"></td>-->
                <!--</tr>-->
                <tr>
                  <th>考生档案所在单位</th>
                  <td colspan="3" id="dangandanweimingcheng">{{ student_unit_name }}</td>
                </tr>
                <tr>
                  <th>考生档案所在单位地址</th>
                  <td colspan="3" id="dangandanweidizhi">{{ student_unit_address }}</td>
                </tr>
                <tr>
                  <th>考生档案所在单位邮政编码</th>
                  <td colspan="3" id="dangandanweiyoubian">{{ student_unit_zip_code }}</td>
                </tr>
                <tr>
                  <th>备用信息</th>
                  <td colspan="3" id="cur_school_info-beiyongxinxi_1">{{ student_alternate_info }}</td>
                </tr>
                <tr>
                  <th>备用信息1</th>
                  <td colspan="3" id="cur_school_info-beiyongxinxi_2">{{ student_alternate_info1 }}</td>
                </tr>
                <tr>
                  <th>何时何地何原因受过何种奖励或处分</th>
                  <td colspan="3" id="jianglichufen">{{ student_reward_punish }}</td>
                </tr>
                <tr>
                  <th>考生作弊情况</th>
                  <td colspan="3" id="zuobiqingkuang">{{ student_cheat }}</td>
                </tr>
                <tr>
                  <th colspan="4">家庭主要成员</th>
                </tr>
                <tr>
                  <th>姓名</th>
                  <th>与本人关系</th>
                  <th>在何单位工作/任何职务</th>
                  <th>联系电话</th>
                </tr>
                <tr>
                  <td id="jiating_xingming_1">{{ student_family_name1 }}</td>
                  <td id="jiating_guanxi_1">{{ student_family_relate1 }}</td>
                  <td id="jiating_zhiwu_1">{{ student_family_work1 }}</td>
                  <td id="jiating_dianhua_1">{{ student_family_phone1 }}</td>
                </tr>
                <tr>
                  <td id="jiating_xingming_2">{{ student_family_name2 }}</td>
                  <td id="jiating_guanxi_2">{{ student_family_relate2 }}</td>
                  <td id="jiating_zhiwu_2">{{ student_family_work2 }}</td>
                  <td id="jiating_dianhua_2">{{ student_family_phone2 }}</td>
                </tr>
                <tr>
                  <td id="jiating_xingming_3">{{ student_family_name3 }}</td>
                  <td id="jiating_guanxi_3">{{ student_family_relate3 }}</td>
                  <td id="jiating_zhiwu_3">{{ student_family_work3 }}</td>
                  <td id="jiating_dianhua_3">{{ student_family_phone3 }}</td>
                </tr>
                <tr>
                  <th colspan="4">学习与工作经历</th>
                </tr>
                <tr>
                  <th>起止年月</th>
                  <th colspan="2">学习或工作单位</th>
                  <th>任何职务</th>
                </tr>
                <tr>
                  <td id="jingli_shijian_1">{{ student_experience_time1 }}</td>
                  <td colspan="2" id="jingli_danwei_1">{{ student_experience_location1 }}</td>
                  <td id="jingli_zhiwu_1">{{ student_experience_work1 }}</td>
                </tr>
                <tr>
                  <td id="jingli_shijian_2">{{ student_experience_time2 }}</td>
                  <td colspan="2" id="jingli_danwei_2">{{ student_experience_location2 }}</td>
                  <td id="jingli_zhiwu_2">{{ student_experience_work2 }}</td>
                </tr>
                <tr>
                  <td id="jingli_shijian_3">{{ student_experience_time3 }}</td>
                  <td colspan="2" id="jingli_danwei_3">{{ student_experience_location3 }}</td>
                  <td id="jingli_zhiwu_3">{{ student_experience_work3 }}</td>
                </tr>
                <tr>
                  <td id="jingli_shijian_4">{{ student_experience_time4 }}</td>
                  <td colspan="2" id="jingli_danwei_4">{{ student_experience_location4 }}</td>
                  <td id="jingli_zhiwu_4">{{ student_experience_work4 }}</td>
                </tr>
                <tr>
                  <td id="jingli_shijian_5">{{ student_experience_time5 }}</td>
                  <td colspan="2" id="jingli_danwei_5">{{ student_experience_location5 }}</td>
                  <td id="jingli_zhiwu_5">{{ student_experience_work5 }}</td>
                </tr>
                <tr>
                  <th>报考单位（名称）</th>
                  <td colspan="3" id="des_school_info-school">{{ unit_university }}</td>
                </tr>
                <tr>
                  <th>报考专业</th>
                  <td colspan="3" id="des_school_info-major">{{ apply_profession }}</td>
                </tr>
                <tr>
                  <th>专项计划</th>
                  <td colspan="3" id="exam_info-zhuanxiangjihua">{{ special_plan_value }}</td>
                </tr>
                <tr>
                  <th>考试方式</th>
                  <td colspan="3" id="exam_info-kaoshifangshi">{{ exam_method_value }}</td>
                </tr>
                <tr>
                  <th>院系</th>
                  <td colspan="3" id="des_school_info-ins">{{ apply_college }}</td>
                </tr>
                <tr>
                  <th>研究方向</th>
                  <td colspan="3" id="des_school_info-sub">{{ apply_direction }}</td>
                </tr>
                <tr>
                  <th>政治理论</th>
                  <td colspan="3">——</td>
                </tr>
                <tr>
                  <th>外国语</th>
                  <td colspan="3">——</td>
                </tr>
                <tr>
                  <th>业务课一</th>
                  <td colspan="3">——</td>
                </tr>
                <tr>
                  <th>业务课二</th>
                  <td colspan="3">——</td>
                </tr>
                <tr>
                  <th>缴费标志</th>
                  <td colspan="3">未交费</td>
                </tr>
                <tr>
                  <th>报名时间</th>
                  <td colspan="3"></td>
                </tr>
                <tr>
                  <th>修改时间</th>
                  <td colspan="3"></td>
                </tr>
                <tr>
                  <th>请输入右侧图片中的文字</th>
                  <td colspan="3" style="position: relative">
                    <input id="captcha" v-model="verification_code"><img
                    style="padding-left: 10px;padding-right: 10px;position: absolute; top: 11px;"
                    src="./img/code.png"><span style="color: red; margin-left: 80px">注：图片中字符为数字</span>
                  </td>
                </tr>
              </table>
            </div>
            <div style="text-align: center; margin-bottom: 100px">
              <el-button type="primary" plain style="margin-top: 20px" @click="handleSelect('6')">返回上一步</el-button>
              <el-button type="primary" plain style="margin-top: 20px; margin-left: 80px" @click="next('8')">
                确认提交，并承诺本人信息完整属实，符合相关规定。
              </el-button>
              <p style="font-size: 14px; margin-bottom: 30px; margin-left: 170px">（请确认选填信息正确无误，报考一旦提交不可修改）</p>
            </div>
          </div>
          <div id="text8">
            <div class="tips">
              <h5 style="font-size: 18px; margin-top: 20px; margin-bottom: 20px">完成报名</h5>
            </div>
            <div style="margin-top: 30px;">
              <div style="margin-bottom: 20px">
              <span style="margin-right: 68px">您的报名信息填写成功！您的报名号是：
                <b style="font-size: 25px; border: solid 1px black; padding: 3px 5px 3px">1</b>
                <b style="font-size: 25px; border: solid 1px black; padding: 3px 5px 3px">2</b>
                <b style="font-size: 25px; border: solid 1px black; padding: 3px 5px 3px">3</b>
                <b style="font-size: 25px; border: solid 1px black; padding: 3px 5px 3px">4</b>
                <b style="font-size: 25px; border: solid 1px black; padding: 3px 5px 3px">5</b>
                <b style="font-size: 25px; border: solid 1px black; padding: 3px 5px 3px">6</b>
                <b style="font-size: 25px; border: solid 1px black; padding: 3px 5px 3px">7</b>
                ，请牢记！
              </span>
                <p style="margin-top: 30px; margin-bottom: 5px">学籍学历校验结果请三日后重新登录网报系统查看。 </p>
                <p style="margin-top: 0px; margin-bottom: 5px">
                  请牢记学信网的用户名密码（为避免个人信息泄漏，请设置复杂密码并定期修改），后期准考证下载、调剂仍然需要使用。</p>
                <p style="margin-top: 0px; margin-bottom: 5px">查看及下载网上报名信息功能将在20xx年xx月xx日xx:xx关闭，下载的 PDF
                  中下方有登录用户名，建议下载保存。 </p>
                <p style="margin-top: 0px; margin-bottom: 5px">为避免报名信息泄漏，请在报名结束后点击页面右上方的"退出登录"退出系统，并关闭所有相关浏览器。 </p>
                <p style="margin-top: 0px; margin-bottom: 30px">如果需要修改信息，请退出系统后重新从研招网首页登录报名系统修改，最终报名信息以现场确认时为准。 </p>
                <p style="margin-bottom: 0px; color: red;">此报考点开通了网上支付，您必须选择网上交费来完成硕士研究生报名，否则此次报名数据无效！ </p>
                <p style="margin-bottom: 0px; color: red;">(在北京、天津、河北、山西、内蒙古、辽宁、吉林、黑龙江、江苏、安徽、福建、江西、山东、河南、湖北、湖南、广西、海南、重庆、四川、贵州、云南、陕西、甘肃、青海、宁夏、新疆等报考点报考的考生，需要网上支付报考费。)</p>
              </div>
            </div>
            <div style="margin-bottom: 30px">
              <el-button type="primary" plain style="margin-top: 20px; ">下载报名信息表</el-button>
              <el-button type="primary" plain style="margin-top: 20px; margin-left: 80px"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;网上交费&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
              <el-button type="primary" plain style="margin-top: 20px; margin-left: 80px" v-on:click="backHome"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;返回首页&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
            </div>
            <div style="margin-bottom: 20px; position: relative">
              <p style="margin-bottom: 10px; margin-left: 14px"><b>小提示：</b></p>
              <div style="display: inline-block">
                <img style="width: 210px; height: 210px;" src="./img/红果研.jpg"/><br>
                <span style="margin-left: 45px">红果研微信公众号</span>
              </div>
              <div style="display: inline-block; width: 70%; position: absolute; top: 60px; margin-left: 20px">
                <p style="margin-top: 0px; margin-bottom: 5px">1、下载 pdf 格式的文件。请 点击此处下载免费 pdf 文件阅读器 Foxit Reader
                  或到其它合法网站自行下载 pdf 阅读器。</p>
                <p style="margin-top: 0px; margin-bottom: 5px">2、如果选择的考点已经开通网上缴费功能（页面有提示），请完成网上缴费，否则报名无效。</p>
                <p style="margin-top: 0px; margin-bottom: 5px">
                  3、特别考点紧缺的个别省份（如成都，上海、等），请尽快完成缴费，不缴费报名未完成，你的座位有可能被人占了，你需要前往更远的地方考试，极其影响自己。</p>
                <p style="margin-top: 0px; margin-bottom: 5px">4、本系统是研究生考试模拟报名系统，为防止考生报名出错供考生训练所用。最终报名请登录中国研究生招生信息网 <a
                  href="http://yz.chsi.com.cn/" target="_blank">http://yz.chsi.com.cn/</a></p>
              </div>
            </div>
            <div style="height: 84px;"></div>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import common from '../../config/config.js'

export default {
  name: 'Process',
  data () {
    return {
      verification_code: '',
      activeIndex: '4',
      exam_method: [{
        value: 1,
        label: '全国统考'
      }, {
        value: 2,
        label: '单独考试'
      }, {
        value: 3,
        label: '管理类联考'
      }, {
        value: 4,
        label: '法硕联考'
      }, {
        value: 5,
        label: '强军计划'
      }, {
        value: 6,
        label: '援藏计划'
      }],
      exam_method_value: '',
      special_plan: [{
        value: 0,
        label: '无'
      }, {
        value: 1,
        label: '强军计划'
      }, {
        value: 2,
        label: '援藏计划'
      }, {
        value: 3,
        label: '少数民族骨干计划'
      }, {
        value: 4,
        label: '退役大学生计划'
      }],
      special_plan_value: '无',
      card_type: [{
        value: 1,
        label: '大陆身份证'
      }, {
        value: 2,
        label: '港澳台身份证'
      }, {
        value: 3,
        label: '华侨身份证/护照'
      }, {
        value: 4,
        label: '军人证件'
      }],
      card_type_value: '',
      serving_soldier: [{
        value: 1,
        label: '非现役军人'
      }, {
        value: 2,
        label: '军队在职干部'
      }, {
        value: 3,
        label: '军校应届本科毕业生'
      }, {
        value: 4,
        label: '国防生'
      }],
      serving_soldier_value: '',
      national: [{
        value: 1,
        label: '汉族'
      }, {
        value: 2,
        label: '壮族'
      }, {
        value: 3,
        label: '满族'
      }, {
        value: 4,
        label: '回族'
      }, {
        value: 5,
        label: '苗族'
      }, {
        value: 6,
        label: '维吾尔族'
      }, {
        value: 7,
        label: '土家族'
      }, {
        value: 8,
        label: '彝族'
      }, {
        value: 9,
        label: '蒙古族'
      }, {
        value: 10,
        label: '藏族'
      }, {
        value: 11,
        label: '布依族'
      }, {
        value: 12,
        label: '侗族'
      }, {
        value: 13,
        label: '瑶族'
      }, {
        value: 14,
        label: '朝鲜族'
      }, {
        value: 15,
        label: '白族'
      }, {
        value: 16,
        label: '哈尼族'
      }, {
        value: 17,
        label: '哈萨克族'
      }, {
        value: 18,
        label: '黎族'
      }, {
        value: 19,
        label: '傣族'
      }, {
        value: 20,
        label: '畲族'
      }, {
        value: 21,
        label: '傈僳族'
      }, {
        value: 22,
        label: '仡佬族'
      }, {
        value: 23,
        label: '东乡族'
      }, {
        value: 24,
        label: '高山族'
      }, {
        value: 25,
        label: '拉祜族'
      }, {
        value: 26,
        label: '水族'
      }, {
        value: 27,
        label: '佤族'
      }, {
        value: 28,
        label: '纳西族'
      }, {
        value: 29,
        label: '羌族'
      }, {
        value: 30,
        label: '土族'
      }, {
        value: 31,
        label: '仫佬族'
      }, {
        value: 32,
        label: '锡伯族'
      }, {
        value: 33,
        label: '柯尔克孜族'
      }, {
        value: 34,
        label: '达斡尔族'
      }, {
        value: 35,
        label: '景颇族'
      }, {
        value: 36,
        label: '毛南族'
      }, {
        value: 37,
        label: '撒拉族'
      }, {
        value: 38,
        label: '塔吉克族'
      }, {
        value: 39,
        label: '阿昌族'
      }, {
        value: 40,
        label: '普米族'
      }, {
        value: 41,
        label: '鄂温克族'
      }, {
        value: 42,
        label: '怒族'
      }, {
        value: 43,
        label: '京族'
      }, {
        value: 44,
        label: '基诺族'
      }, {
        value: 45,
        label: '德昂族'
      }, {
        value: 46,
        label: '保安族'
      }, {
        value: 47,
        label: '俄罗斯族'
      }, {
        value: 48,
        label: '裕固族'
      }, {
        value: 49,
        label: '乌兹别克族'
      }, {
        value: 50,
        label: '门巴族'
      }, {
        value: 51,
        label: '鄂伦春族'
      }, {
        value: 52,
        label: '独龙族'
      }, {
        value: 53,
        label: '塔塔尔族'
      }, {
        value: 54,
        label: '赫哲族'
      }, {
        value: 55,
        label: '珞巴族'
      }, {
        value: 56,
        label: '布朗族'
      }],
      national_value: '',
      sex: [{
        value: 1,
        label: '男'
      }, {
        value: 2,
        label: '女'
      }],
      sex_value: '',
      marriage: [{
        value: 1,
        label: '未婚'
      }, {
        value: 2,
        label: '已婚'
      }, {
        value: 3,
        label: '离婚'
      }],
      marriage_value: '',
      political_outlook: [{
        value: 1,
        label: '中国共产主义青年团团员'
      }, {
        value: 2,
        label: '中国共产党党员'
      }, {
        value: 3,
        label: '中国共产党预备党员'
      }, {
        value: 4,
        label: '中国国民党革命委员会会员'
      }, {
        value: 5,
        label: '中国民主同盟盟员'
      }, {
        value: 6,
        label: '中国民主建国会会员'
      }, {
        value: 7,
        label: '中国民主促进会会员'
      }, {
        value: 8,
        label: '中国农工民主党党员'
      }, {
        value: 9,
        label: '中国致公党党员'
      }, {
        value: 10,
        label: '九三学社社员'
      }, {
        value: 11,
        label: '台湾民主自治同盟盟员'
      }, {
        value: 12,
        label: '无党派民主人士'
      }, {
        value: 13,
        label: '群众'
      }],
      political_outlook_value: '',
      sources: [{
        value: 1,
        label: '普通全日制应届本科毕业生'
      }, {
        value: 2,
        label: '科学研究人员'
      }, {
        value: 3,
        label: '高等教育教师'
      }, {
        value: 4,
        label: '中等教育教师'
      }, {
        value: 5,
        label: '其他在职人员'
      }, {
        value: 6,
        label: '成人应届本科毕业生'
      }, {
        value: 7,
        label: '其他人员'
      }],
      sources_value: '',
      end_learn_way: [{
        value: 1,
        label: '普通全日制'
      }, {
        value: 2,
        label: '成人教育'
      }, {
        value: 3,
        label: '自学考试'
      }, {
        value: 4,
        label: '网络教育'
      }, {
        value: 5,
        label: '获境外学历或学位证书者'
      }, {
        value: 6,
        label: '其他'
      }],
      end_learn_way_value: '',
      final_education: [{
        value: 1,
        label: '普通全日制应届本科毕业生'
      }, {
        value: 2,
        label: '科学研究人员'
      }, {
        value: 3,
        label: '高等教育教师'
      }, {
        value: 4,
        label: '中等教育教师'
      }, {
        value: 5,
        label: '其他在职人员'
      }, {
        value: 6,
        label: '成人应届本科毕业生'
      }, {
        value: 7,
        label: '其他人员'
      }],
      final_education_value: '',
      years: [{
        value: 1,
        label: '1990'
      }, {
        value: 2,
        label: '1991'
      }, {
        value: 3,
        label: '1992'
      }, {
        value: 4,
        label: '1993'
      }, {
        value: 5,
        label: '1994'
      }, {
        value: 6,
        label: '1995'
      }, {
        value: 7,
        label: '1996'
      }, {
        value: 8,
        label: '1997'
      }, {
        value: 9,
        label: '1998'
      }, {
        value: 10,
        label: '1999'
      }, {
        value: 11,
        label: '2000'
      }, {
        value: 12,
        label: '2001'
      }, {
        value: 13,
        label: '2002'
      }, {
        value: 14,
        label: '2003'
      }, {
        value: 15,
        label: '2004'
      }, {
        value: 16,
        label: '2005'
      }, {
        value: 17,
        label: '2006'
      }, {
        value: 18,
        label: '2007'
      }, {
        value: 19,
        label: '2008'
      }, {
        value: 20,
        label: '2009'
      }, {
        value: 21,
        label: '2010'
      }, {
        value: 22,
        label: '2011'
      }, {
        value: 23,
        label: '2012'
      }, {
        value: 24,
        label: '2013'
      }, {
        value: 25,
        label: '2014'
      }, {
        value: 26,
        label: '2015'
      }, {
        value: 27,
        label: '2016'
      }, {
        value: 28,
        label: '2017'
      }, {
        value: 29,
        label: '2018'
      }, {
        value: 30,
        label: '2019'
      }, {
        value: 31,
        label: '2020'
      }],
      years_value: '',
      monthes: [{
        value: 1,
        label: '01'
      }, {
        value: 2,
        label: '02'
      }, {
        value: 3,
        label: '03'
      }, {
        value: 4,
        label: '04'
      }, {
        value: 5,
        label: '05'
      }, {
        value: 6,
        label: '06'
      }, {
        value: 7,
        label: '07'
      }, {
        value: 8,
        label: '08'
      }, {
        value: 9,
        label: '09'
      }, {
        value: 10,
        label: '10'
      }, {
        value: 11,
        label: '11'
      }, {
        value: 12,
        label: '12'
      }],
      monthes_value: '',
      final_degree: [{
        value: 1,
        label: '学士'
      }, {
        value: 2,
        label: '硕士'
      }, {
        value: 3,
        label: '博士'
      }],
      final_degree_value: '',
      exam_category: [{
        value: 1,
        label: '非定向就业'
      }, {
        value: 2,
        label: '定向就业'
      }],
      exam_category_value: '',
      student_name: '',
      student_name_pinyin: '',
      student_card_number: '',
      student_mail_address: '',
      student_zip_code: '',
      student_telephone: '',
      student_mobile_phone: '',
      student_email: '',
      student_number: '',
      student_diploma_number: '',
      student_degree_number: '',
      student_alternate_info: '',
      student_alternate_info1: '',
      student_detail_address: '',
      student_study_work_unit: '',
      student_unit_name: '',
      student_unit_address: '',
      student_unit_zip_code: '',
      student_reward_punish: '',
      student_cheat: '',
      student_family_name1: '',
      student_family_relate1: '',
      student_family_work1: '',
      student_family_phone1: '',
      student_family_name2: '',
      student_family_relate2: '',
      student_family_work2: '',
      student_family_phone2: '',
      student_family_name3: '',
      student_family_relate3: '',
      student_family_work3: '',
      student_family_phone3: '',
      student_experience_time1: '',
      student_experience_location1: '',
      student_experience_work1: '',
      student_experience_time2: '',
      student_experience_location2: '',
      student_experience_work2: '',
      student_experience_time3: '',
      student_experience_location3: '',
      student_experience_work3: '',
      student_experience_time4: '',
      student_experience_location4: '',
      student_experience_work4: '',
      student_experience_time5: '',
      student_experience_location5: '',
      student_experience_work5: '',
      //
      provinces: '',
      origin_cities: '',
      origin_counties: '',
      location_cities: '',
      location_counties: '',
      birth_cities: '',
      birth_counties: '',
      file_cities: '',
      file_counties: '',
      //
      origin_province: '',
      origin_city: '',
      origin_county: '',
      location_province: '',
      location_city: '',
      location_county: '',
      birth_province: '',
      birth_city: '',
      birth_county: '',
      file_province: '',
      file_city: '',
      file_county: '',
      //
      unit_city: '',
      unit_cities: '',
      unit_university: '',
      unit_universities: '',
      graduate_city: '',
      graduate_university: '',
      graduate_universities: '',
      graduate_college: '',
      graduate_colleges: '',
      graduate_profession: '',
      graduate_professions: '',
      //
      apply_college: '',
      apply_colleges: '',
      apply_profession: '',
      apply_professions: '',
      apply_direction: '',
      apply_directions: '',
      apply_subject: '',
      apply_point: ''
    }
  },
  methods: {
    handleSelect (key) {
      // console.log(typeof key)
      if (key === '5') {
        if (this.unit_city === '' || this.unit_university === '' || this.exam_method_value === '') {
          this.$notify({
            title: '警告',
            message: '必填项不可为空',
            type: 'warning'
          })
          return
        }
      } else if (key === '6') {
        if (this.apply_college === '' || this.apply_profession === '' || this.apply_direction === '') {
          this.$notify({
            title: '警告',
            message: '必填项不可为空',
            type: 'warning'
          })
          return
        }
      } else if (key === '7') {
        if (this.apply_point === '') {
          this.$notify({
            title: '警告',
            message: '必填项不可为空',
            type: 'warning'
          })
          return
        }
      }
      const texts = [4, 5, 6, 7, 8]
      for (let i in texts) {
        document.getElementById('text' + texts[i]).style.display = 'none'
      }
      const dis = window.getComputedStyle(document.getElementById('text' + key)).display
      if (dis === 'none') {
        document.getElementById('text' + key).style.display = 'block'
      }
      // if (key === '10') {
      //   var items = document.getElementsByClassName('el-menu-item')
      //   var i
      //   for (i = 0; i <= items.length - 1; i++) {
      //     items[i].className += ' is-disabled'
      //   }
      //   return
      // }
      this.activeIndex = key
    },
    next (num) {
      var params = {
        'unit_city': this.unit_city,
        'unit_university': this.unit_university,
        'exam_method': this.exam_method_value,
        'special_plan': this.special_plan_value,
        'name': this.student_name,
        'name_pinyin': this.student_name_pinyin,
        'card_type': this.card_type_value,
        'card_number': this.student_card_number,
        'soldier_type': this.serving_soldier_value,
        'national': this.national_value,
        'gender': this.sex_value,
        'marriage': this.marriage_value,
        'political_outlook': this.political_outlook_value,
        'mail_address': this.student_mail_address,
        'zip_code': this.student_zip_code,
        'telephone': this.student_telephone,
        'mobile_phone': this.student_mobile_phone,
        'email': this.student_email,
        'source': this.sources_value,
        'end_learn_way': this.end_learn_way_value,
        'final_education': this.final_education_value,
        'learn_number': this.student_number,
        'diploma_number': this.student_diploma_number,
        'year': this.years_value,
        'month': this.monthes_value,
        'final_degree': this.final_degree_value,
        'degree_number': this.student_degree_number,
        'graduate_city': this.graduate_city,
        'graduate_university': this.graduate_university,
        'graduate_college': this.graduate_college,
        'graduate_profession': this.graduate_profession,
        'exam_category': this.exam_category_value,
        'spare_info': this.student_alternate_info,
        'spare_info1': this.student_alternate_info1,
        'origin_province': this.origin_province,
        'origin_city': this.origin_city,
        'origin_county': this.origin_county,
        'location_province': this.location_province,
        'location_city': this.location_city,
        'location_county': this.location_county,
        'detail_address': this.student_detail_address,
        'birth_province': this.birth_province,
        'birth_city': this.birth_city,
        'birth_county': this.birth_county,
        'study_work_unit': this.student_study_work_unit,
        'file_province': this.file_province,
        'file_city': this.file_city,
        'file_county': this.file_county,
        'unit_name': this.student_unit_name,
        'unit_address': this.student_unit_address,
        'unit_zip_code': this.student_unit_zip_code,
        'reward_punish': this.student_reward_punish,
        'cheat': this.student_cheat,
        'apply_college': this.apply_college,
        'apply_profession': this.apply_profession,
        'apply_direction': this.apply_direction,
        'apply_point': this.apply_point,
        //
        'family_name1': this.student_family_name1,
        'family_relate1': this.student_family_relate1,
        'family_work1': this.student_family_work1,
        'family_phone1': this.student_family_phone1,
        'family_name2': this.student_family_name2,
        'family_relate2': this.student_family_relate2,
        'family_work2': this.student_family_work2,
        'family_phone2': this.student_family_phone2,
        'family_name3': this.student_family_name3,
        'family_relate3': this.student_family_relate3,
        'family_work3': this.student_family_work3,
        'family_phone3': this.student_family_phone3,
        //
        'experience_time1': this.student_experience_time1,
        'experience_location1': this.student_experience_location1,
        'experience_work1': this.student_experience_work1,
        'experience_time2': this.student_experience_time2,
        'experience_location2': this.student_experience_location2,
        'experience_work2': this.student_experience_work2,
        'experience_time3': this.student_experience_time3,
        'experience_location3': this.student_experience_location3,
        'experience_work3': this.student_experience_work3,
        'experience_time4': this.student_experience_time4,
        'experience_location4': this.student_experience_location4,
        'experience_work4': this.student_experience_work4,
        'experience_time5': this.student_experience_time5,
        'experience_location5': this.student_experience_location5,
        'experience_work5': this.student_experience_work5
      }
      console.log(params)
      if (this.verification_code !== '9316') {
        this.$alert('验证码错误', '红果研教育', {
          confirmButtonText: '确定'
        })
      } else {
        this.$http.post(common.ROOT_API_URL + '/student/', params)
          .then((response) => {
            if (response.data.retCode === 1) {
              // console.log(response.data)
              this.$alert('信息不能全部为空', '红果研教育', {
                confirmButtonText: '确定'
              })
            } else {
              this.$notify({
                title: '红果研教育',
                message: '保存成功',
                type: 'success'
              })
              this.handleSelect(num)
            }
          })
      }
    },
    currentOriginProvince (val) {
      this.origin_city = ''
      this.origin_county = ''
      this.$http.get(common.ROOT_API_URL + '/address/cities/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.origin_cities = response.data.data
        })
    },
    currentOriginCity (val) {
      this.origin_county = ''
      this.$http.get(common.ROOT_API_URL + '/address/counties/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.origin_counties = response.data.data
        })
    },
    currentLocationProvince (val) {
      this.location_city = ''
      this.location_county = ''
      this.$http.get(common.ROOT_API_URL + '/address/cities/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.location_cities = response.data.data
        })
    },
    currentLocationCity (val) {
      this.location_county = ''
      this.$http.get(common.ROOT_API_URL + '/address/counties/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.location_counties = response.data.data
        })
    },
    currentBirthProvince (val) {
      this.birth_city = ''
      this.birth_county = ''
      this.$http.get(common.ROOT_API_URL + '/address/cities/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.birth_cities = response.data.data
        })
    },
    currentBirthCity (val) {
      this.birth_county = ''
      this.$http.get(common.ROOT_API_URL + '/address/counties/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.birth_counties = response.data.data
        })
    },
    currentFileProvince (val) {
      this.file_city = ''
      this.file_county = ''
      this.$http.get(common.ROOT_API_URL + '/address/cities/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.file_cities = response.data.data
        })
    },
    currentFileCity (val) {
      this.file_county = ''
      this.$http.get(common.ROOT_API_URL + '/address/counties/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.file_counties = response.data.data
        })
    },
    currentUnitCity (val) {
      this.unit_university = ''
      this.$http.get(common.ROOT_API_URL + '/unit/universities/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.unit_universities = response.data.data
        })
    },
    currentGraduateCity (val) {
      this.graduate_university = ''
      this.graduate_college = ''
      this.graduate_profession = ''
      this.$http.get(common.ROOT_API_URL + '/unit/universities/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.graduate_universities = response.data.data
        })
    },
    currentGraduateUniversity (val) {
      this.graduate_college = ''
      this.graduate_profession = ''
      this.$http.get(common.ROOT_API_URL + '/colleges/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.graduate_colleges = response.data.data
        })
    },
    currentGraduateCollege (val) {
      this.graduate_profession = ''
      this.$http.get(common.ROOT_API_URL + '/professions/?college_name=' + val + '&university_name=' + this.graduate_university)
        .then((response) => {
          // console.log(response.data.data)
          this.graduate_professions = response.data.data
        })
    },
    currentUnitUniversity (val) {
      this.apply_college = ''
      this.apply_profession = ''
      this.apply_direction = ''
      this.$http.get(common.ROOT_API_URL + '/apply/colleges/?name=' + val)
        .then((response) => {
          // console.log(response.data.data)
          this.apply_colleges = response.data.data
        })
    },
    currentApplyCollege (val) {
      this.apply_profession = ''
      this.apply_direction = ''
      this.$http.get(common.ROOT_API_URL + '/apply/professions/?college_name=' + val + '&university_name=' + this.unit_university)
        .then((response) => {
          // console.log(response.data.data)
          this.apply_professions = response.data.data
        })
    },
    currentApplyProfession (val) {
      this.apply_direction = ''
      this.$http.get(common.ROOT_API_URL + '/apply/directions/?profession_name=' + val + '&college_name=' + this.apply_college + '&university_name=' + this.unit_university)
        .then((response) => {
          // console.log(response.data.data)
          this.apply_directions = response.data.data
        })
    },
    backHome () {
      this.$router.push({path: '/'})
    }
  },
  mounted: function () {
    this.$http.get(common.ROOT_API_URL + '/address/provinces/')
      .then((response) => {
        // console.log(response.data.data)
        this.provinces = response.data.data
      })
    this.$http.get(common.ROOT_API_URL + '/unit/cities/')
      .then((response) => {
        // console.log(response.data.data)
        this.unit_cities = response.data.data
      })
  }
}
</script>

<style scoped>
  h4 {
    text-align: center;
    margin: 0px;
    padding-top: 21px;
    padding-bottom: 21px;
    background-color: #FFFFFF;;
    border-bottom: solid 1px #E5E5E5;
  }

  #title {
    position: fixed;
    top: 0;
    left: 17.1%;
    z-index: 10;
    width: 66.7%;
  }

  #text {
    margin-left: 23%;
    margin-top: 40px;
    margin-right: 5%;
  }

  .tips {
    border-bottom: solid 1px #E5E5E5;
  }

  table {
    border-collapse: collapse;
    width: 100%
  }

  table, td, th {
    border: 1px solid #E5E5E5;
    background-color: #F6FAFE;
  }

  td, th {
    height: 40px;
    text-align: left;
    padding-left: 10px;
  }

  th {
    width: 220px;
  }

  #text5, #text6, #text7, #text8 {
    display: none;
  }

  a {
    text-decoration: none;
    color: #409EFF;
  }

  a:hover {
    color: white;
  }

  .clear {
    clear: both;
  }

  .el-select__caret {
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/Process/Process.vue